<header class="ia-page-header">
  <div class="ia-page-header__intro">
    <h1 #pageTitle tabindex="-1">{{ title }}</h1>
    <p *ngIf="description">{{ description }}</p>
  </div>
  <div class="ia-page-header__actions"><ng-content></ng-content></div>
</header>
